// extracted by mini-css-extract-plugin
export var compact = "_ov-2";
export var phoneFrame = "_ov-0";
export var phoneScreen = "_ov-1";